import { sessionStorageKeyIsRedirectedToG500Lite } from '../const/commonConst';
import { g500LiteBaseURL } from '../const/url';
import { getSessionStorage, setSessionStorage } from './sessionStorageHandler';

/**
 * 初回リダイレクト時にG500Lite Webアプリのログインページに遷移する関数
 */
const redirectToG500LiteLoginPage = () => {
	// リダイレクト済みかのフラグを取得
	const isRedirectedToG500Lite = getSessionStorage(sessionStorageKeyIsRedirectedToG500Lite);

	// 初回のリダイレクトの場合は、ログインページにリダイレクト
	if (!isRedirectedToG500Lite) {
		try {
			setSessionStorage(sessionStorageKeyIsRedirectedToG500Lite, 'true');
		} catch (error: unknown) {
			// WebStorageErrorについてはloginHandlerでハンドリングするため、ここでは処理しない
			console.error(error);
		}
		window.open(`${g500LiteBaseURL}/index.html`, '_blank');
		return true;
	}

	return false;
};

/**
 * G500Lite Webアプリのトップページに遷移する関数
 */
export const redirectToG500LiteTopPage = () => {
	const isRedirectedToLoginPage = redirectToG500LiteLoginPage();

	if (isRedirectedToLoginPage) {
		return;
	}

	window.open(`${g500LiteBaseURL}/mainMenu.html`, '_blank');
};

/**
 * G500Lite Webアプリの車両情報をみるページに遷移する関数
 */
export const redirectToG500LiteCarInfoPage = () => {
	const isRedirectedToLoginPage = redirectToG500LiteLoginPage();

	if (isRedirectedToLoginPage) {
		return;
	}

	window.open(`${g500LiteBaseURL}/carInfo.html`, '_blank');
};

/**
 * G500Lite Webアプリの映像をみるページに遷移する関数
 */
export const redirectToG500LiteMoveInfoPage = () => {
	const isRedirectedToLoginPage = redirectToG500LiteLoginPage();

	if (isRedirectedToLoginPage) {
		return;
	}

	window.open(`${g500LiteBaseURL}/moveInfo.html`, '_blank');
};
